<template>
  <page-header-wrapper @back="back">
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('下单人')" prop="buyerKeyword">
                <a-input v-model="queryParam.buyerKeyword" :maxLength="32" :placeholder="$t('请输入昵称或手机号')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商品名称')" prop="productName">
                <a-input v-model="queryParam.productName" :maxLength="32" :placeholder="$t('请输入')+$t('商品名称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('下单时间')" prop="orderTimeRange">
                <a-range-picker
                  v-model="orderTimeRange"
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  @change="handleOrderTimeChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          style="margin-bottom: 24px;"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="status" slot-scope="text">
          {{ orderStatusMap[text] || text }}
        </span>
        <span slot="productPic" slot-scope="text">
          <a-avatar v-if="text" shape="square" :size="48" :src="text" />
          <span v-else>-</span>
        </span>
        <span slot="orderTime" slot-scope="text, record">
          {{ parseTime(record.orderTime) }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUnionPromotionOrder } from '@/api/union/unionPromotionOrder'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UnionPromotionOrder',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      orderTimeRange: [],
      orderStatusMap: {
        2010: this.$t('待付款'),
        2020: this.$t('待发货'),
        2030: this.$t('待收货'),
        2050: this.$t('已完成'),
        2060: this.$t('已取消'),
        2070: this.$t('交易关闭')
      },
      // 高级搜索 展开/关闭
      advanced: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        allianceId: undefined,
        promoterUserId: undefined,
        orderId: undefined,
        orderSn: undefined,
        buyerUserId: undefined,
        buyerKeyword: undefined,
        productId: undefined,
        skuId: undefined,
        productName: undefined,
        orderBeginTime: undefined,
        orderEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('订单编号'),
          dataIndex: 'orderSn',
          width: '120px',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('下单人昵称'),
          dataIndex: 'buyerName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('下单人手机号'),
          dataIndex: 'buyerPhone',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('联盟者'),
          dataIndex: 'allianceName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品名称'),
          dataIndex: 'productName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品图片'),
          dataIndex: 'productPic',
          scopedSlots: { customRender: 'productPic' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品单价'),
          dataIndex: 'unitPrice',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('购买数量'),
          dataIndex: 'quantity',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('获得佣金'),
          dataIndex: 'commissionAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('下单时间'),
          dataIndex: 'orderTime',
          scopedSlots: { customRender: 'orderTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    const id = this.$route.query && this.$route.query.allianceId
    if (id) {
      this.queryParam.allianceId = id
    }
    this.getList()
  },
  watch: {},
  methods: {
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询联盟推广订单关联列表 */
    getList() {
      this.loading = true
      pageUnionPromotionOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        allianceId: this.$route.query && this.$route.query.allianceId,
        promoterUserId: undefined,
        orderId: undefined,
        orderSn: undefined,
        buyerUserId: undefined,
        buyerKeyword: undefined,
        productId: undefined,
        skuId: undefined,
        productName: undefined,
        orderBeginTime: undefined,
        orderEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.orderTimeRange = []
      this.handleQuery()
    },
    handleOrderTimeChange(value) {
      this.queryParam.orderBeginTime = value && value[0]
      this.queryParam.orderEndTime = value && value[1]
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /** 关闭按钮 */
    back() {
      this.$router.push({ path: '/union/union/alliance' })
    }
  }
}
</script>
